import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../app/store';
import { Note } from 'types/data/note.t';

// Define a type for the slice state
interface NotesState {
  value: Note[];
}

// Define the initial state using that type
const initialState: NotesState = {
  value: []
};

export const notesSlice = createSlice({
  name: 'notes',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    addNote: (state, action: PayloadAction<Note>) => {
      state.value = [...state.value, action.payload];
    },
    removeNote: (state, action: PayloadAction<number>) => {
      state.value = state.value.filter(p => p.id !== action.payload);
    },
    // Use the PayloadAction type to declare the contents of `action.payload`
    updateNote: (state, action: PayloadAction<Note>) => {
      state.value = state.value.map(p => (p.id === action.payload.id ? action.payload : p));
    }
  }
});

export const { addNote, removeNote, updateNote } = notesSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectnotes = (state: RootState) => state.notes.value;

export default notesSlice.reducer;
